import { FieldError, Input, Label } from 'components/core-v2/atoms'
import { useFormContext } from 'react-hook-form'

import { FIELDS } from '../constants'
import { FieldProps } from '../field'
import { required } from '../validators'
import classes from './index.module.scss'

export interface AuthyCodeField {
  authy1?: number
  authy2?: number
  authy3?: number
  authy4?: number
  authy5?: number
  authy6?: number
}

const INPUT_IDS = [1, 2, 3, 4, 5, 6]

export const AuthyCode = ({ isDisabled }: Partial<FieldProps>) => {
  const {
    formState: { errors },
    register
  } = useFormContext<AuthyCodeField>()

  const hasError =
    Boolean(errors.authy1?.message) ||
    Boolean(errors.authy2?.message) ||
    Boolean(errors.authy3?.message) ||
    Boolean(errors.authy4?.message) ||
    Boolean(errors.authy5?.message) ||
    Boolean(errors.authy6?.message)

  const errorId = 'authy-error'

  return (
    <fieldset className={classes.root}>
      <Label className="mb-3">{FIELDS.authyCode.label}</Label>
      <div className={classes.inputWrapper}>
        {INPUT_IDS.map(id => {
          const inputId = `authy${id}`
          return (
            <Input
              key={inputId}
              data-private
              aria-describedby={errorId}
              aria-label={`authy code ${id}`}
              className={classes.input}
              hasError={hasError}
              id={inputId}
              inputMode="numeric"
              isDisabled={isDisabled}
              maxLength={1}
              type="text"
              {...register(inputId as keyof AuthyCodeField, {
                ...required,
                setValueAs: (value?: string) => {
                  const { length } = value || ''
                  // Focus the next input
                  if (length === 1 && id !== 6) {
                    document.getElementById(`authy${id + 1}`).focus()
                  }
                  // Normalize the value at a single character
                  return length > 1 ? value[0] : value
                }
              })}
            />
          )
        })}
      </div>

      {hasError && <FieldError id={errorId}>The code must be 6 digits</FieldError>}
    </fieldset>
  )
}
